import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { EventsProvider } from "@/contexts/eventscontent";
import { LeadershipProvider } from "@/contexts/LeadershipContext";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY || "";

createRoot(document.getElementById("root")!).render(
  <GoogleReCaptchaProvider
    reCaptchaKey={recaptchaSiteKey}
    scriptProps={{
      async: false,
      defer: false,
      appendTo: "head",
      nonce: undefined,
    }}
  >
    <EventsProvider>
      <LeadershipProvider>
        <App />
      </LeadershipProvider>
    </EventsProvider>
  </GoogleReCaptchaProvider>
);
